/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Document type
 */
export enum FinnairBoardingPassDocumentType {
  PDF = 'PDF',
  PDF_V_2 = 'PDF_V2',
  APPLE_WALLET = 'APPLE_WALLET',
  APPLE_WALLET_V_2 = 'APPLE_WALLET_V2',
  GOOGLE_WALLET = 'GOOGLE_WALLET',
  RAW_DATA = 'RAW_DATA'
}

